import { BASE_URL, useFetch, requestSdk, post } from 'utils/sdk';

export interface StudentsDataListFilterProps {
  gender: string;
  ethnicity: string;
  grade: string;
  template_grade: string;
  state: string;
  is_low_income: string;
  is_on_individualized_education_plan: string;
  assignment_name: string;
  standard_code: string;
  english_learner_status: string;
  limit: number;
  offset: number;
}

export interface StudentResponse {
  overall_response_data: {
    description: string;
  };
  misconceptions_data: Array<{
    id: number;
    name: string;
  }>;
  enrollment_data: {
    ethnicity: string;
    gender: string;
    state: string;
    grade: number;
    is_low_income: string;
    is_on_individualized_education_plan: string;
    english_learner_status: string;
  };
  // these will be returned only on review
  assignment_data: {
    assignment_name: string;
    standards_list: Array<string>;
  };
  file_url: URL;
  research_portal_id: string;
}
export interface StudentsDataListResponse {
  results: StudentResponse[];
  count: number;
  next: string | null;
  previous: string | null;
}

export interface SDKResponse {
  data: Object,
  errors: Array<string>,
  success: boolean
}

export const useStudentsDatasetList = ({
  filters
}: {
  filters?: StudentsDataListFilterProps;
}) =>
  useFetch<StudentsDataListResponse>(`/api/v1/tags/research-portal/dataset/`, {
    ...filters
  });

export const getStudentsDatasetExportURL = ({
  filters
}: {
  filters: StudentsDataListFilterProps;
}) => {
  return `${BASE_URL}/api/v1/tags/research-portal/export/?gender=${filters.gender}&ethnicity=${filters.ethnicity}&grade=${filters.grade}&template_grade=${filters.template_grade}&state=${filters.state}&is_low_income=${filters.is_low_income}&is_on_individualized_education_plan=${filters.is_on_individualized_education_plan}&assignment_name=${filters.assignment_name}&standard_code=${filters.standard_code}&english_learner_status=${filters.english_learner_status}`;
};

export const callStudentsDatasetExportImagesZipURL = ({
  filters
}: {
  filters?: StudentsDataListFilterProps
}): Promise<SDKResponse> =>
  requestSdk(() =>
    post<void>(
      `${BASE_URL}/api/v1/tags/research-portal/export-images-to-zip/`,
      { filters }
    )
  );

export interface USStatesListResponse {
  name: string;
  abbreviation: string;
}
export const useUsStates = () =>
  useFetch<Array<USStatesListResponse>>(`/api/v1/schools/states/`);
